import { jsx } from "react/jsx-runtime";
import { Tr } from "@pcln/horizon";
import "react";
const CustomTableTr = (props)=>/*#__PURE__*/ jsx(Tr, {
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            if (props.isStreaming) return;
            const currentTarget = event.currentTarget;
            const anchorTag = currentTarget.querySelector('a');
            if (anchorTag?.hasAttribute?.('href')) {
                const href = anchorTag.getAttribute('href');
                window.open(href, '_blank');
                return;
            }
            const innerText = currentTarget.innerText;
            props?.submitChatMessageInMarkerComponent?.({
                role: 'user',
                content: `Select ${innerText}`
            });
        },
        children: props.children
    });
export { CustomTableTr };
